<div style=overflow-x:auto;overflow-y:hidden v-html=svgSchema v-resize=onResize> </div>